import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { INCOME_ACCOUNT_TYPE } from "./incomes.constants";

export function useIncomeStructures() {
  return useAccountTypeStructures(INCOME_ACCOUNT_TYPE);
}
